/* ==========================================================================
   Royal Care Professional — collection filters

   The filter form works on its own: it is a plain GET form and the Apply
   button submits it. This file only adds the conveniences.

   - Desktop: ticking a box applies straight away, so Apply is redundant.
   - Mobile: the sidebar is a drawer, and changes are batched until Apply is
     tapped, because reloading the page under someone's thumb is hostile.
   ========================================================================== */

(function () {
  'use strict';

  if (window.RCCollection) {
    window.RCCollection.init();
    return;
  }

  var DRAWER = '(max-width: 989px)';

  function Collection(root) {
    this.root = root;
    this.form = root.querySelector('[data-rc-coll-form]');
    this.sidebar = root.querySelector('[data-rc-coll-sidebar]');
    this.overlay = root.querySelector('[data-rc-coll-overlay]');
    this.openBtn = root.querySelector('[data-rc-coll-open]');
    this.closeBtn = root.querySelector('[data-rc-coll-close]');
    this.sort = root.querySelector('[data-rc-coll-sort]');
  }

  Collection.prototype.isDrawer = function () {
    return window.matchMedia(DRAWER).matches;
  };

  Collection.prototype.submit = function () {
    if (!this.form) return;
    // requestSubmit runs validation and fires submit handlers; submit() does not.
    if (this.form.requestSubmit) this.form.requestSubmit();
    else this.form.submit();
  };

  Collection.prototype.openDrawer = function () {
    if (!this.sidebar) return;
    this.overlay.hidden = false;
    requestAnimationFrame(
      function () {
        this.sidebar.classList.add('is-open');
        this.overlay.classList.add('is-visible');
      }.bind(this)
    );
    this.openBtn.setAttribute('aria-expanded', 'true');
    document.body.style.overflow = 'hidden';

    var first = this.sidebar.querySelector('button, input, select, a');
    if (first) first.focus();
  };

  Collection.prototype.closeDrawer = function () {
    if (!this.sidebar) return;
    this.sidebar.classList.remove('is-open');
    this.overlay.classList.remove('is-visible');
    this.openBtn.setAttribute('aria-expanded', 'false');
    document.body.style.overflow = '';

    window.setTimeout(
      function () {
        this.overlay.hidden = true;
      }.bind(this),
      340
    );

    this.openBtn.focus();
  };

  Collection.prototype.bind = function () {
    var self = this;

    if (this.openBtn) this.openBtn.addEventListener('click', this.openDrawer.bind(this));
    if (this.closeBtn) this.closeBtn.addEventListener('click', this.closeDrawer.bind(this));
    if (this.overlay) this.overlay.addEventListener('click', this.closeDrawer.bind(this));

    document.addEventListener('keydown', function (event) {
      if (event.key !== 'Escape') return;
      if (self.sidebar && self.sidebar.classList.contains('is-open')) self.closeDrawer();
    });

    // Sorting always applies immediately, on any screen size.
    if (this.sort) {
      this.sort.addEventListener('change', function () {
        self.submit();
      });
    }

    if (!this.form) return;

    this.form.addEventListener('change', function (event) {
      // On mobile the visitor batches their choices and taps Apply.
      if (self.isDrawer()) return;
      if (event.target.type === 'number') return; // price waits for blur
      self.submit();
    });

    // Price inputs apply once the visitor is done typing.
    this.form.addEventListener(
      'blur',
      function (event) {
        if (self.isDrawer()) return;
        if (event.target.type !== 'number') return;
        if (event.target.value === event.target.defaultValue) return;
        self.submit();
      },
      true
    );

    this.form.addEventListener('keydown', function (event) {
      if (event.key !== 'Enter' || event.target.type !== 'number') return;
      event.preventDefault();
      self.submit();
    });

    // Leaving the drawer breakpoint with it open would strand body overflow.
    var mq = window.matchMedia(DRAWER);
    var onChange = function (event) {
      if (!event.matches) {
        document.body.style.overflow = '';
        if (self.sidebar) self.sidebar.classList.remove('is-open');
        if (self.overlay) {
          self.overlay.classList.remove('is-visible');
          self.overlay.hidden = true;
        }
      }
    };
    mq.addEventListener ? mq.addEventListener('change', onChange) : mq.addListener(onChange);
  };

  var RCCollection = {
    init: function (root) {
      var scope = root || document;
      Array.prototype.forEach.call(scope.querySelectorAll('[data-rc-coll]'), function (el) {
        if (el.dataset.rcCollReady === 'true') return;
        el.dataset.rcCollReady = 'true';
        new Collection(el).bind();
      });
    }
  };

  window.RCCollection = RCCollection;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      RCCollection.init();
    });
  } else {
    RCCollection.init();
  }

  document.addEventListener('shopify:section:load', function (event) {
    RCCollection.init(event.target);
  });
})();
